import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiCustom from "../../utils/ApiCustom";

const ChangePassword = () => {
  const [data, setData] = useState({});
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisible2, setPasswordVisible2] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const userId = localStorage.getItem("userId");
  const getData = () => {
    ApiCustom.get("/user-show/" + userId)
      .then((res) => {
        setData(res.data.data?.data);
      })
      .catch((err) => console.log(err));
  };

  const handleSubmit = () => {
    const postData = {
      ...data,
      password: password,
      rePassword: password2,
    };

    ApiCustom.put("/user-update", postData)
      .then((res) => {
        if (res.status == 200) {
          setOldPassword("");
          setPassword("");
          setPassword2("");
          toast.success("Cập nhật mật khẩu thành công");
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCheckOldPassword = () => {
    ApiCustom.post(
      "/check-old-password",
      {
        id: Number(userId),
        password: oldPassword,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((res) => {
        if (res.data?.status == 200) {
          if (res.data?.data == true) {
            const passwordRegex =
              /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;

            if (!passwordRegex.test(password)) {
              setErrorPassword(
                "Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số và 1 ký tự đặc biệt"
              );
              return;
            }

            if (password !== password2) {
              toast.error("Nhập lại mật khẩu không đúng");
              return;
            }
            handleSubmit();
          } else {
            toast.error("Mật khẩu cũ sai");
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Đổi mật khẩu</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 border-t">
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-1">
              Mật khẩu cũ
              <i className="text-red-600"> *</i>
            </label>
            <div className="relative">
              <input
                type={oldPasswordVisible ? "text" : "password"}
                name="oldPassword"
                value={oldPassword}
                onChange={(e) => {
                  setOldPassword(e.target.value);
                  setErrorPassword("");
                }}
                className={`w-full p-2 border rounded-md  focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
              />
              <button
                type="button"
                onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {oldPasswordVisible ? "Ẩn" : "Hiện"}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Mật khẩu mới
              <i className="text-red-600"> *</i>
            </label>
            <div className="relative">
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorPassword("");
                }}
                className={`w-full p-2 border rounded-md  focus:ring-2 ${
                  errorPassword ? "border-red-500" : "border-gray-300"
                } focus:ring-blue-500 focus:border-transparent`}
              />
              <button
                type="button"
                onClick={() => setPasswordVisible(!passwordVisible)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {passwordVisible ? "Ẩn" : "Hiện"}
              </button>
            </div>
            {errorPassword && (
              <p className="mt-1 text-sm text-red-600">{errorPassword}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Nhập lại mật khẩu
              <i className="text-red-600"> *</i>
            </label>
            <div className="relative">
              <input
                type={passwordVisible2 ? "text" : "password"}
                name="password2"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                className={`w-full p-2 border rounded-md  focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
              />
              <button
                type="button"
                onClick={() => setPasswordVisible2(!passwordVisible2)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {passwordVisible2 ? "Ẩn" : "Hiện"}
              </button>
            </div>
          </div>
          <div className="flex justify-end">
            <button
              className="btn btn-outline btn-success"
              onClick={handleCheckOldPassword}
              disabled={oldPassword == ""}
            >
              Xác nhận
            </button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"></div>
    </div>
  );
};

export default ChangePassword;
